var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileRepairCategories(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62469 14.7555H16.2497V16.016H6.62469V14.7555ZM1.92906 15.3857L0.155313 17.0117L1.12469 17.9066L3.87469 15.3857L1.12469 12.8649L0.148438 13.7535L1.92906 15.3857ZM6.62469 8.45345H16.2497V9.71387H6.62469V8.45345ZM1.92906 9.08366L0.155313 10.7096L1.12469 11.6045L3.87469 9.08366L1.12469 6.56283L0.148438 7.45142L1.92906 9.08366ZM6.62469 2.15137H16.2497V3.41178H6.62469V2.15137ZM1.92906 2.78158L0.155313 4.40751L1.12469 5.30241L3.87469 2.78158L1.12469 0.260742L0.148438 1.14934L1.92906 2.78158Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileRepairCategories);
export default __webpack_public_path__ + "static/media/profileRepairCategories.84cb1762fc741e64c15cd1754037b7e5.svg";
export { ForwardRef as ReactComponent };